import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const ClientExports = React.lazy(
    () => import(/* webpackChunkName: "client-exports" */ '../../../../containers/Client/Exports')
);

export const ClientExportsRoutes: RouteObject = {
    path: 'exports',
    element: (
        <React.Suspense fallback={<>...</>}>
            <ClientExports />
        </React.Suspense>
    )
};
